import React, { useEffect, useState } from 'react';
import PageHeader from '../../../components/headers/PageHeader';
import {
  Table,
  Button,
  message,
  Form,
  Input,
  DatePicker,
  Row,
  Skeleton,
  Col,
  Radio,
} from 'antd';
import ContratosObraFaenaColumns from './componnetsTabs/ContratosObraFaenaColumns';
import xinerlinkBackofficeService from '../../../services/xinerlinkBackofficeService';
import Labels from '../../../utils/Labels.json';
import locale from 'antd/es/date-picker/locale/es_ES';
// import dayjs from 'dayjs';
import BotonDescargaMasiva from './Xinerlink/BotonDescargaMasiva';
import BotonDescargaExcel from './Xinerlink/BotonDescargaExcel';
import dayjs from 'dayjs';

export default function TabContratosObraFaena({ setRefresh, refresh }) {
  // const tipo = 'contratosTrabajador';
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loadingRefersh, setLoadingRefersh] = useState(true);
  const [loading, setLoading] = useState(true);
  const [openedRecord, setOpenedRecord] = useState(null);
  const [estadoContrato, setEstadoContrato] = useState('Activo');
  const [data, setData] = useState([]);

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      // console.log(selectedRowKeys);
      setSelectedRowKeys(selectedRows);
    },
  };

  const AjusteArrayTrabajadores = (data) => {
    const arrayTrabajadoresContratos = [];
    if (data.length !== 0) {
      const arrayFiltrado = data.filter((item) => item.idContrato !== 0);
      arrayFiltrado.forEach(function (obj) {
        let nexElement = obj;
        nexElement.idOferta = obj.idOferta.toString();
        nexElement.idContrato = obj.idContrato.toString();
        nexElement.key = obj.idContrato.toString() + obj.idOferta.toString();

        arrayTrabajadoresContratos.unshift(nexElement);
      });
      arrayTrabajadoresContratos.sort((a, b) => b.idOferta - a.idOferta);
      setFilteredData(
        arrayTrabajadoresContratos.map((item) => {
          return {
            ...item,
            fechaInicio: item.fechaInicio
              ? dayjs(item.fechaInicio).format('DD/MM/YYYY')
              : '',
            fechaFin: item.fechaFin
              ? dayjs(item.fechaFin).format('DD/MM/YYYY')
              : '',
          };
        })
      );

      setLoadingRefersh(false);
      setLoading(false);
    } else {
      setFilteredData([]);
      setLoadingRefersh(false);
      setLoading(false);
    }
  };

  const VerContratosObraFaena = async () => {
    try {
      setLoading(true);
      const [res] = await xinerlinkBackofficeService.obtenerContratosObraFaena({
        estadoContrato: estadoContrato || '',
      });
      setLoading(false);
      if (res.data.ok) {
        AjusteArrayTrabajadores(res.data.contratos || []);
        setData(res.data.contratos || []);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const [filteredData, setFilteredData] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleSearch = async () => {
    try {
      setLoading(true);
      const respuestaContratos =
        await xinerlinkBackofficeService.obtenerContratosObraFaena({
          estadoContrato: estadoContrato || '',
        });
      setLoading(false);
      // debug && console.log(respuestaContratos);
      if (respuestaContratos[0].data.ok) {
        AjusteArrayTrabajadores(
          filtrarData(respuestaContratos[0].data.contratos || [])
        );
        setData(respuestaContratos[0].data.contratos || []);
      } else {
        message.error('No se encontraron contratos');
        AjusteArrayTrabajadores([]);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleReset = () => {
    setStartDate(null);
    setEndDate(null);
    VerContratosObraFaena();
  };

  useEffect(() => {
    VerContratosObraFaena();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);

  useEffect(() => {
    if (startDate || endDate) {
      AjusteArrayTrabajadores(filtrarData(data));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  const filtrarData = (data) => {
    let dataFiltrada = data;
    if (startDate) {
      dataFiltrada = dataFiltrada.filter((item) => {
        return (
          dayjs(item.fechaInicio).isSame(startDate, 'day') ||
          dayjs(item.fechaInicio).isAfter(startDate, 'day')
        );
      });
    }
    if (endDate) {
      dataFiltrada = dataFiltrada.filter((item) => {
        return (
          dayjs(item.fechaInicio).isSame(endDate, 'day') ||
          dayjs(item.fechaInicio).isBefore(endDate, 'day')
        );
      });
    }
    return dataFiltrada;
  };

  return (
    <div>
      <PageHeader title="Contratos Obra Faena" head="">
        <BotonDescargaMasiva
          selectedRowKeys={selectedRowKeys}
          tipo="Contratos"
        />
        <BotonDescargaMasiva
          selectedRowKeys={selectedRowKeys}
          tipo="Documentos"
        />
        <BotonDescargaExcel
          data={filteredData}
          filename="ContratosTrabajadores"
        />
      </PageHeader>
      {loadingRefersh ? (
        <Skeleton />
      ) : (
        <div style={{ margin: '10px' }}>
          <Row style={{ marginBotton: '20px' }}>
            {/* <Col>
              <div style={{ marginTop: '5px', marginRight: '10px' }}>
                Filtro por fecha o RUT:
              </div>{' '}
            </Col> */}
            <Col>
              {' '}
              <Form layout="inline">
                <Form.Item label="Estado">
                  <Radio.Group
                    onChange={(data) => setEstadoContrato(data.target.value)}
                    value={estadoContrato}
                    defaultValue={'Activo'}
                    disabled={loading}>
                    <Radio value={'Activo'}>Activos</Radio>
                    <Radio value={'Inactivo'}>Inactivos</Radio>
                    <Radio value={''}>Todos</Radio>
                  </Radio.Group>
                </Form.Item>
                {/* <Form.Item label="RUT">
                  <Input
                    placeholder="Rut"
                    style={{ width: '100%' }}
                    onChange={(e) => {
                      setRut(e.target.value);
                    }}
                  />
                </Form.Item> */}
                <Form.Item label="Desde">
                  <DatePicker
                    placeholder="Desde"
                    onChange={(date) => setStartDate(date)}
                    style={{ width: '100%' }}
                    locale={locale}
                    format={'DD/MM/YYYY'}
                  />
                </Form.Item>
                <Form.Item label="Hasta">
                  <DatePicker
                    placeholder="Hasta"
                    onChange={(date) => setEndDate(date)}
                    style={{ width: '100%' }}
                    locale={locale}
                    format={'DD/MM/YYYY'}
                  />
                </Form.Item>
                <Form.Item>
                  <Input
                    type="submit"
                    value="Buscar"
                    onClick={handleSearch}
                    disabled={loading}
                  />
                </Form.Item>
              </Form>
            </Col>
            <Col>
              <Button onClick={() => handleReset()} disabled={loading}>
                {' '}
                Borrar
              </Button>
            </Col>
          </Row>

          <Table
            style={{ marginTop: '20px' }}
            rowKey="key"
            rowSelection={{
              type: 'checkbox',
              ...rowSelection,
            }}
            pagination={{ showSizeChanger: true }}
            locale={Labels['tableLabels']}
            loading={loading}
            dataSource={filteredData}
            columns={ContratosObraFaenaColumns(
              filteredData,
              openedRecord,
              setOpenedRecord
            )}
            scroll={{ x: 'max-content' }}
          />
        </div>
      )}
    </div>
  );
}
